/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerDemographicsRoutingModule
 * Purpose		: Routing module for CustomerDemographics.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CustomerDemographicsListComponent } from './CustomerDemographicsList.component';
import { CustomerDemographicsAddComponent }  from './CustomerDemographicsAdd.component';
import { CustomerDemographicsEditComponent } from './CustomerDemographicsEdit.component';
import { CustomerDemographicsDetailsComponent } from './CustomerDemographicsDetails.component';

const CustomerDemographicsRoutes: Routes = [
	{ path: 'CustomerDemographics',  component: CustomerDemographicsListComponent },
	{ path: 'CustomerDemographics/add', component: CustomerDemographicsAddComponent },
	{ path: 'CustomerDemographics/:id', component: CustomerDemographicsEditComponent },
	{ path: 'CustomerDemographics/Details/:id', component: CustomerDemographicsDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(CustomerDemographicsRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class CustomerDemographicsRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerDemographics/CustomerDemographics-routing.module.ts